import React from 'react';
import { Alert } from '@mui/material';
import { useContext } from 'react';
import VerificationContext from '@containers/form-verification/verification/context';

const BgvDegreeInstituteName: React.FC = () => {
  const context = useContext(VerificationContext);
  const config = context?.misc;
  const scraperInstitutes =
    config?.configData?.additionalInfo?.authOptions[0]?.candidateIdSchemaByInstitute;
  const { fields } = context?.states || {};
  const instituteName = fields?.[0]?.nameOfInstitute;
  const isInstituteInScraper = !!(instituteName && scraperInstitutes?.[instituteName]);
  return (
    <>
      {isInstituteInScraper ? (
        <Alert
          severity="info"
          sx={{
            color: '#073B72',
            backgroundColor: '#E4F1FF',
            fontWeight: '400',
            paddingTop: '8px',
            paddingBottom: '8px',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
            mt: 2
          }}>
          For Smoother verification, please enter your{' '}
          {scraperInstitutes?.[instituteName]?.fieldName} in the following format, as found on your
          degree or marksheet:
          <br />
          <b>Use this format:</b> {scraperInstitutes?.[instituteName]?.format}
          <br />
          <br />
          <p>
            If this format is not available on your document, you may instead enter the Registration
            Number, Roll Number, Identifier, or Serial Number as shown on the certificate or
            marksheet.
          </p>
        </Alert>
      ) : (
        <></>
      )}
    </>
  );
};

export default BgvDegreeInstituteName;
